import { Typography } from '@material-ui/core';
import React from 'react';
import MessageBox from './MessageBox';

function NoDataVisual({ message = 'No data' }) {
  return (
    <MessageBox>
      <Typography variant="body1" align="left">
        {message}
      </Typography>
    </MessageBox>
  );
}

export default NoDataVisual;
